"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAndAppendElement = void 0;
const createElement_1 = require("./createElement");
function createAndAppendElement(parentElement, template) {
    const element = (0, createElement_1.createElement)(template);
    parentElement.append(element);
    return element;
}
exports.createAndAppendElement = createAndAppendElement;
